



















import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IInvoice } from "@/models/invoices";

@Component({
  components: {
    "select-order": () =>
      import("@/components/app/admin/settings/orderTemplates/selectOrder.vue")
  }
})
export default class SelectOrderModal extends Vue {
  // Props

  @Prop({ default: null })
  public selectedOrderId!: IInvoice["id"];

  @Prop({ default: () => ({}) })
  public readonly manualFilters!: { [key: string]: string | number | boolean };

  // Variables

  public selectedId = this.selectedOrderId;

  // Methods

  public saveChanges() {
    this.$emit("success", this.selectedId);
    this.$emit("close");
  }

  public onSelect(value) {
    this.selectedId = value;
  }

  // Getters

  public get isDisabled() {
    return (
      this.$_.isNull(this.selectedId) ||
      this.selectedId === this.selectedOrderId
    );
  }
}
